import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import get from 'lodash.get';

export const EXPENSE_CARD_SETTINGS = gql`
  query expenseCardSettings($projectId: String!) {
    expenseCardSettings(projectId: $projectId) {
      allowBillable
      showActuals
    }
  }
`;

export const useExpenseCardSettings = ({ projectId }) => {
  const { data, loading } = useQuery(EXPENSE_CARD_SETTINGS, {
    variables: { projectId },
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first'
  });

  const expenseCardSettings = get(data, 'expenseCardSettings', {});

  return {
    loading,
    expenseCardSettings
  };
};

export default useExpenseCardSettings;
